export default __webpack_public_path__ + "static/media/216.cf5ac20b.jpg";